import { render, staticRenderFns } from "./closingPositionDetail.vue?vue&type=template&id=d3bfa710"
import script from "./closingPositionDetail.vue?vue&type=script&lang=ts"
export * from "./closingPositionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports